































































import { Component, Vue, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

/**
 * Utils
 */
import classes from "@/config/wow/classes";
import * as externalLinks from "@/config/external-links";
import * as imageLinks from "@/config/image-links";
import armorTypes from "@/config/wow/armor-types";

import { colorPlayerCount } from "./lib/helpers";

import { getElegantDateString } from "@/utils/date-helpers";

/**
 * Components
 */
import GroupCard from "@/components/_global/GroupCard.vue";

/**
 * API
 */
import { GetOneTeamResponse } from "@/api/teams/get-one-team.response";

/**
 * Types
 */
import { Guid } from "@/domain/guid";
import { GetOneCompositionGroupResponse } from "@/api/compositions/get-one-composition-group.response";
import DataFetcher from "@/components/_global/DataFetcher.vue";


/**
 * VueX Modules
 */
const teamModule = namespace("team");

/**
 * Compositions' comparison page.
 */
@Component({
	components: {
		DataFetcher,
		GroupCard
	}
})
export default class CompositionsComparePage extends Vue {
	/// Injections
	classes = classes;
	externalLinks = externalLinks;
	imageLinks = imageLinks;
	armorTypes = armorTypes;
	colorPlayerCount = colorPlayerCount;
	getElegantDateString = getElegantDateString;

	/// Props
	@Prop()
	compositionGroup!: GetOneCompositionGroupResponse | null;
	@Prop()
	notifyFetchCompositionGroup!: () => Promise<void>;

	/// Attributes
	isLoading = false;
	firstCompositionID: Guid | null = null;
	secondCompositionID: Guid | null = null;

	/// VueX Modules
	@teamModule.State("team")
	currentTeam!: GetOneTeamResponse;

	get firstComposition() {
		if (this.firstCompositionID == null || this.compositionGroup == null) {
			return null;
		}
		return this.compositionGroup.compositions.find(x => x.id === this.firstCompositionID);
	}

	get secondComposition() {
		if (this.secondCompositionID == null || this.compositionGroup == null) {
			return null;
		}
		return this.compositionGroup.compositions.find(x => x.id === this.secondCompositionID);
	}

	get usefulCompositions() {
		if (this.compositionGroup == null) {
			return null;
		}
		return this.compositionGroup.compositions;
	}

	/// Methods
	async created() {
	}

	async fetch() {
		await this.fetchCompositionGroup();
	}

	async fetchCompositionGroup() {
		await this.notifyFetchCompositionGroup();
	}

}
